module.exports = __webpack_public_path__ + "img/2026big1.7fd0a8ea.png";